import { CountryZodSchema, isAValidCountry } from '#shared/country.model.js';
import { FEATURE_PERMISSIONS, KPI_GRANULARITIES, PERIOD_GRANULARITIES, PERMISSIONS } from '#shared/permission/index.js';
import { z } from 'zod';
export const DEFAULT_CARREFOUR_REFERENTIAL_INTERVAL = 'standard';
export const authorizationContextResourceNames = ['holding', 'supplier_key', '*'];
const AuthorizationContextResourceZodSchema = z.object({
    name: z.enum(authorizationContextResourceNames),
    value: z.string()
});
const AuthorizationContextZodSchema = z.object({
    product: z.object({
        carrefour: AuthorizationContextResourceZodSchema.array().readonly(),
        nielsen: AuthorizationContextResourceZodSchema.array().readonly()
    })
});
export const UserScopeZodSchema = z.object({
    organization: z.object({
        id: z.string().readonly(),
        externalId: z.string().readonly(),
        country: z.string().refine(isAValidCountry).readonly(),
        name: z.string().readonly()
    }),
    authorizationContext: AuthorizationContextZodSchema,
    permissions: z
        .object({
        periods: z.enum(PERIOD_GRANULARITIES).array().readonly(),
        kpis: z.enum(KPI_GRANULARITIES).array().readonly(),
        features: z.enum(FEATURE_PERMISSIONS).array().readonly()
    })
        .readonly(),
    flags: z
        .object({
        isAdmin: z.boolean().optional().readonly(),
        isAccountManager: z.boolean().optional().readonly(),
        isOrganizationsCreator: z.boolean().optional().readonly(),
        isCarrefour: z.boolean().optional().readonly(),
        isAnonymized: z.boolean().optional().readonly()
    })
        .readonly()
});
/**
 * Dulicated type from @prisma/client to prevent exposing Prisma type to the frontend through trpc
 * This must be synced with the @prisma/client Role enum
 */
export const USER_ROLE_NAMES = [
    'ADMIN',
    'METRIC_VIEWER',
    'PROJECT_VIEWER',
    'PROJECT_MANAGER',
    'ACCOUNT_MANAGER',
    'ADMIN',
    'ORGANIZATIONS_CREATOR'
];
export function isUserRoleName(roleName) {
    return USER_ROLE_NAMES.includes(roleName);
}
export const UserFieldsSchema = z.object({
    id: z.string(),
    email: z.email(),
    displayName: z.string(),
    activationState: z.enum(['pending', 'accepted', 'rejected']),
    avatarUrl: z.string().optional(),
    isImpersonating: z.boolean().optional()
});
const RoleWithPermissionsSchema = z.object({
    organizationId: z.string(),
    name: z.enum(USER_ROLE_NAMES),
    Permissions: z.array(z.object({
        object: z.enum(PERMISSIONS),
        action: z.string()
    }))
});
export const AUTH_URI_REGEX = /^gcs.(fra|esp|bel).(product).(carrefour|nielsen)\/(?!\/)((?:(?:holding|supplier_key)(?:\/[\w*-]+))|\*)$/;
export const AuthUriZodSchema = z.string().regex(AUTH_URI_REGEX);
const AuthApiUserScopeSchema = z.object({
    organizationAuthUris: z.array(AuthUriZodSchema)
});
export const UserOrganizationSchema = z.object({
    id: z.string(),
    externalId: z.string(),
    name: z.string(),
    country: CountryZodSchema
});
export const AuthenticatedUserZodSchema = UserFieldsSchema.extend({
    roles: z.array(RoleWithPermissionsSchema),
    // Those are null while the user hasn't yet fulfilled the Company selection part of the onboarding
    scope: AuthApiUserScopeSchema.nullable(),
    organization: UserOrganizationSchema.nullable()
});
export const USER_ORGANIZATION_RELATION = {
    internal: 'internal',
    external: 'external'
};
//# sourceMappingURL=userScope.model.js.map